import coinImg from '@assets/web-v3-images/coin.png';
import facebookImg from '@assets/web-v3-images/icons/facebook-icon.png';
import puzzleImg from '@assets/web-v3-images/icons/puzzle-popup.png';
import teleImg from '@assets/web-v3-images/icons/tele-icon.png';
import tiktokImg from '@assets/web-v3-images/icons/tiktok-icon.png';
import warningImg from '@assets/web-v3-images/icons/warning.png';
import { Text } from '@radix-ui/themes';
import ActionSuccessPopup from '.';
import Buttons from '../Buttons';
import { useTranslation } from 'react-i18next';

const Texts = ({ text = 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' }) => {
	return (
		<Text as='p' className='text-[rgba(161,92,7,1)] font-medium 
					text-[12px] sm:text-[16px] md:text-[16px] lg:text-[16px] xl:text-[16px]
					text-center pt-5 w-60 sm:w-90 md:w-90 lg:w-90 xl:w-95'>
			{text}
		</Text>
	)
}
const Titles = ({ title = 'Lorem ipsum dolor sit amet consectetur adipisicing elit.', classNames }) => {
	return (
		<Text as='p' className={`text-[rgba(119,41,23,1)] font-bold 
				text-[20px] sm:text-[26px] md:text-[28px] lg:text-[28px] xl:text-[28px] 
				!leading-[25px] sm:!leading-[29px] md:!leading-[32px] lg:!leading-[32px] xl:!leading-[32px]
				 text-center w-50 
				 pt-7 sm:pt-13 md:pt-20 lg:pt-20 xl:pt-20 ${classNames}`}>
			{title}
		</Text>
	)
}
const Images = ({ src, text }) => {
	return (
		<div className="flex flex-col items-center">
			<img
				src={src}
				alt="src"
				className="w-12 sm:w-22 md:w-22 lg:w-22 xl:w-22 h-auto mt-2 sm:mt-10 md:mt-10 lg:mt-10 xl:mt-10 btn-click-active"
			/>
			<Text className='font-bold text-[rgba(122,46,14,1)] text-[11px] sm:text-[17px] md:text-[17px] lg:text-[17px] xl:text-[17px]'>{text}</Text>
		</div>
	)
}
// ---------UI-----------
const MissYourRewards = () => {
	return (
		<>
			<Titles title="Don't miss your rewards!" />
			<Texts text='You have 2 free Coins left today. Play Shwe Puzzle now to collect your puzzle pieces!' />
			<img src={puzzleImg} alt="puzzle-popup" className='h-full w-22 sm:w-38 md:w-40 lg:w-40 xl:w-40 mt-10' />
		</>
	)
}
const FollowUs = () => {
	return (
		<>
			<Titles title='Follow us!' />
			<Texts text="Follow ShweDeal so you don't miss out on prizes!" />
			<div className="grid grid-cols-3 gap-4 w-full">
				<Images src={facebookImg} text='Facebook' />
				<Images src={tiktokImg} text='Tiktok' />
				<Images src={teleImg} text='Tele Group' />
			</div>
		</>
	)
}
const SuccessfullyWithdrawn = ({ value, t }) => {

	return (
		<>
			<Titles title={t("loyalty_point.redeem_successful")} classNames='w-100' />
			<div className='flex gap-1.5 justify-center pt-6'>
				<img src={coinImg} alt="coin" className='w-12 sm:w-15 md:w-22 lg:w-22 xl:w-22 h-full self-center' />
				<span
					className='font-extrabold text-[35px] sm:text-[60px] md:text-[80px] lg:text-[80px] xl:text-[80px]'
					style={{
						background: "linear-gradient(180deg, #F49062 0%, #FD371F 100%)",
						WebkitBackgroundClip: "text",
						WebkitTextFillColor: "transparent",
					}}
				>
					{value?.amount?.toLocaleString('en-US') || 0}
				</span>
			</div>
			<Texts text={t("loyalty_point._LP_have_been_credited_to_your_Mytel_Loyalty_Wallet").replace("_LP_", value?.amount?.toLocaleString('en-US') || 0) + value?.external_ref_id} />
		</>
	)
}
const ErrorWithdrawn = ({ t }) => {
	return (
		<>
			<img src={warningImg} alt="coin" className='w-18 sm:w-20 md:w-30 lg:w-30 xl:w-30 h-full self-center pt-12 sm:pt-23 md:pt-23 lg:pt-23 xl:pt-23' />
			<p className='text-[rgba(119,41,23,1)] text-center font-bold text-[16px] sm:text-[20px] md:text-[20px] lg:text-[20px] xl:text-[20px] w-60 sm:w-100 md:w-100 lg:w-100 xl:w-100'>
				{t("loyalty_point.your_loyalty_points_will_expire_in_3_days")}
			</p>
		</>
	)
}

const SuccessWithdrawn = ({ t }) => {
	return (
		<>
			<img src={warningImg} alt="coin" className='w-18 sm:w-20 md:w-30 lg:w-30 xl:w-30 h-full self-center pt-12 sm:pt-23 md:pt-23 lg:pt-23 xl:pt-23' />
			<p className='text-[rgba(119,41,23,1)] text-center font-bold text-[16px] sm:text-[20px] md:text-[20px] lg:text-[20px] xl:text-[20px] w-60 sm:w-100 md:w-100 lg:w-100 xl:w-100'>
				{t("loyalty_point.congratulations_you_unlocked_the_1000_LP")}
			</p>
		</>
	)
}

export default function FollowPopup({ value, open, onOpenChange, handleClick, textBtn = 'Test demo', type = '2' }) {
	const { t } = useTranslation()

	// truyền type để có UI tương ứng
	let ui = null;
	switch (type) {
		case "1":
			ui = <MissYourRewards />;
			break;
		case "2":
			ui = <FollowUs />;
			break;
		case "3":
			ui = <SuccessfullyWithdrawn value={value} t={t} />;
			break;
		case "4":
			ui = <ErrorWithdrawn t={t} />;
			break;
		case "5":
			ui = <SuccessWithdrawn t={t} />;
			break;
		default:
			ui = null;
	}

	return (
		<ActionSuccessPopup
			open={open}
			onOpenChange={onOpenChange}
		>
			<div className="w-full flex flex-col items-center justify-center px-8 sm:px-10 md:px-25 lg:px-25 xl:px-25">
				{ui}
				<div className='absolute bottom-0 sm:bottom-0 md:bottom-0 lg:bottom-5 xl:bottom-5 px-10 sm:px-22'>
					<Buttons handleClick={handleClick} textBtn={textBtn} />
				</div>
			</div>

		</ActionSuccessPopup>
	)
}
